/**
 * @file equal Judge whether two variables are exactly equal.
 * @author yuzong(yuzong@tencent.com)
 */

/**
 * Judge whether two variables are exactly equal.
 *
 * @param first First variable.
 * @param second Second variable.
 * @return Are the first and second exactly equal.
 */
export function equal(first, second) {
  if (first === second) {
    return first !== 0 || second !== 0 || 1 / Number(first) === 1 / Number(second);
  } // eslint-disable-next-line no-self-compare


  return first !== first && second !== second;
}